export class ContactUsRequest {
    FullName: string;
    Email: string;
    PhoneNumber: string;
    Type: string;
    Info: string;
    CustNo: string;
}
